import { render, staticRenderFns } from "./libros.vue?vue&type=template&id=7445d981"
import script from "./libros.vue?vue&type=script&lang=js"
export * from "./libros.vue?vue&type=script&lang=js"
import style0 from "./libros.vue?vue&type=style&index=0&id=7445d981&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports